import './TextLesson.scss';
type TextLessonProps = {
  text: string;
};

export const TextLesson = ({ text }: TextLessonProps) => {
  return <div className='text-content lesson-content'>{text}</div>;
};
